// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconAnnotationsModeFreehand_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M2 22.5061L7.65685 5.53553L12.6066 7.65685L14.0208 6.24264L12.6066 4.82843L15.435 2L22.5061 9.07107L19.6777 11.8995L18.2635 10.4853L16.8492 11.8995L18.9706 16.8492L2 22.5061ZM8.71751 8.01041L5.53553 17.5563L9.26026 13.8316C9.08208 13.1644 9.25472 12.423 9.77817 11.8995C10.5592 11.1184 11.8256 11.1184 12.6066 11.8995C13.3877 12.6805 13.3877 13.9469 12.6066 14.7279C12.0831 15.2514 11.3417 15.424 10.6745 15.2458L6.94975 18.9706L16.4957 15.7886L14.7279 11.1924L16.8492 9.07107L15.435 7.65685L13.3137 9.77817L8.71751 8.01041Z" class="svg-bg"/>
</svg>
`;
/**
 * IconAnnotationsModeFreehand is a generated icon component.
 */
let IconAnnotationsModeFreehand = IconAnnotationsModeFreehand_1 = class IconAnnotationsModeFreehand extends IconBaseElement {
    render() {
        return html `${IconAnnotationsModeFreehand_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconAnnotationsModeFreehand.icons = new Map([
    ['s8', _s24IconSvg],
    ['s12', _s24IconSvg],
    ['s16', _s24IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s24IconSvg],
    ['s40', _s24IconSvg],
    ['s48', _s24IconSvg],
    ['s64', _s24IconSvg],
    ['s72', _s24IconSvg],
    ['s80', _s24IconSvg],
]);
IconAnnotationsModeFreehand = IconAnnotationsModeFreehand_1 = __decorate([
    customElement('zui-icon-annotations-mode-freehand')
], IconAnnotationsModeFreehand);
export { IconAnnotationsModeFreehand };
